import { slugify } from '~~/utils';

export const DEFAULT_REGION_COUNTRY = 'Brasil';
const MIN_REGION_CANONICAL_SLUG_PARTS = 4;

type RegionPathInput = {
	name?: string | null;
	city?: string | null;
	state?: string | null;
	country?: string | null;
};

function getNormalizedCountry(country?: string | null): string {
	return country?.trim() || DEFAULT_REGION_COUNTRY;
}

function getSlugPart(value?: string | null): string {
	return slugify(value || '');
}

export function getNormalizedRegionSlug(slug?: string | null): string {
	return getSlugPart(slug);
}

export function getRegionCanonicalSlug({
	name,
	city,
	state,
	country
}: RegionPathInput): string {
	const regionSlugParts = [
		getSlugPart(name),
		getSlugPart(city),
		getSlugPart(state)
	];

	if (regionSlugParts.some(slugPart => !slugPart)) return '';

	return [...regionSlugParts, getSlugPart(getNormalizedCountry(country))].join(
		'-'
	);
}

export function getRegionPath(region: RegionPathInput): string {
	const slug = getNormalizedRegionSlug(region.name);

	return slug ? `/bairros/${slug}` : '/bairros';
}

export function looksLikeRegionCanonicalSlug(slug?: string | null): boolean {
	const slugParts = getNormalizedRegionSlug(slug).split('-').filter(Boolean);

	if (slugParts.length < MIN_REGION_CANONICAL_SLUG_PARTS) return false;

	const stateSlug = slugParts.at(-2);

	return !!stateSlug && /^[a-z]{2}$/.test(stateSlug);
}
